var $ = global.jQuery = global.$;

var utils = require('../lib/utils');
var _debounce = require('lodash/function/debounce');
var _Base = require('./_Base');

/**
 * Widget for equalising the heights of the elements passed via the `data-equalise-targets` attribute
 * @class
 * @extends _Base
 */
var Equalise = _Base.extend(
  /** @lends Equalise.prototype */
  {
  /**
   * Initialises the widget
   * @private
   */
  init: function() {
    var self = this;

    this._debouncedResizeHandler = _debounce(this._resizeHandler, 400);

    this.eqTargets = this.$el.data('equaliseTargets') ? this.$el.data('equaliseTargets') : '.equal';

    this.getTargets();

    setTimeout(this.equalise.bind(this), 200);

    this.w = utils.getWindow().width;

    $(window).on('resize orientationchange', this._debouncedResizeHandler.bind(this));

  },
  /**
   * Handles resize event
   * @private
   */
  _resizeHandler: function() {
    if (utils.getWindow().width !== this.w){
      this.equalise();
      this.w = utils.getWindow().width;
    }
  },
  getTargets: function() {
    this.$targets = this.$el.find(this.eqTargets);
  },
  /**
   * Equalises all the target elements
   */
  equalise: function() {
    var self = this;
    var counter = 0;
    var images = this.$el.find('img');
    if (images.length > 0) {
      images.each(function() {
        if (this.complete) {
          counter++;
          if (counter === images.length) {
            self.equaliseItems();
          }
        } else {
          $(this).on('load error', function() {
            counter++;
            if (counter === images.length) {
              self.equaliseItems();
            }
          });
        }
      });
    } else {
      this.equaliseItems();
    }
  },
  /**
   * Figures out which items are in the same row and equalises each row.
   */
  equaliseItems: function() {
    var self = this;
    var maxHeight = 0;
    var rows = {};

    this.$targets.each(function() {
      $(this).css({
        'height': 'auto'
      });
    });

    this.$targets.each(function() {
      var offset = $(this).offset().top + '';
      var thisHeight = $(this).outerHeight();

      if (!rows[offset]) {
        rows[offset] = {
          items: [],
          maxHeight: 0
        };
      }

      rows[offset].items.push($(this));

      rows[offset].maxHeight = thisHeight > rows[offset].maxHeight ? thisHeight : rows[offset].maxHeight;
    });

    $.each(rows, function() {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].outerHeight(this.maxHeight);
        if (i === this.items.length - 1) {
          self.$el.trigger('Equalised', [this.maxHeight]);
        }
      }
    });
  }
});

module.exports = Equalise;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Equalise.js
// module id = 24
// module chunks = 0 1